import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import grey from '@material-ui/core/colors/grey';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';

import {
	IApplication,
	setLectureCancelData,
	showLectureCancelDialog,
} from '../actions/imstat';
import { IMessage } from '../actions/message';
import { ICareerInfo, ICurriculumInfo } from '../actions/search';
import MessageDialog from '../components/MessageDialog';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ImstatScenarioFactory, {
	IFetchLectureCancelDataParam,
	ISaveLectureCancelParam,
} from '../scenario/ImstatScenarioFactory';
import SearchScenarioFactory from '../scenario/SearchScenarioFactory';
import { isMobile } from '../utils/MobileCheck';

const styles = (theme: Theme) =>
	createStyles({
		button: {
			margin: '10px',
		},
		cellItemName: {
			backgroundColor: grey[300],
			minWidth: '150px',
			textAlign: 'right',
			width: '20%',
		},
		cellItemValue: {
			textAlign: 'left',
			width: '80%',
		},
		column: {
			display: 'inline-block',
			textAlign: 'center',
			width: '100%',
		},
		flex: {
			flex: 1,
		},
		mobileCellItemName: {
			alignItems: 'center',
			backgroundColor: grey[300],
			display: 'flex',
			minHeight: '40px',
			minWidth: '10px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileCellItemValue: {
			alignItems: 'center',
			display: 'flex',
			minHeight: '40px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileTable: {
			minWidth: '100px',
		},
		root: {
			flexGrow: 1,
			padding: 18,
			wordBreak: 'break-all',
		},
		tableLayout: {
			tableLayout: 'fixed',
		},
		textArea: {
			width: '100%',
		},
		whiteSpace: {
			whiteSpace: 'normal',
		},
		whiteSpaceMenuItem: {
			whiteSpace: 'normal',
			'word-break': 'break-all',
		},
		wrapDiv: {
			margin: '10px',
		},
	});

interface IRouteParams {
	career_id: IState['careerID'];
	class_id: IState['classID'];
	curriculum_flg: string;
}

interface IRouteState {
	caller: Parameters<IProps['pushHistory']>[0];
	skillViewFlg: Parameters<IProps['pushHistory']>[0];
}

interface IState {
	careerID: string;
	careerTitle: string;
	classID: string;
	curriculumFlg: boolean;
	openErrorMessageDialog: boolean;
	messages: IMessage[];
}

/**
 * 受講取消
 */
class LectureCancel extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			careerID: '',
			careerTitle: '',
			classID: '',
			curriculumFlg: false,
			messages: [],
			openErrorMessageDialog: false,
		};

		this.errorMessageDialogClose = this.errorMessageDialogClose.bind(this);
		this.onDialogOk = this.onDialogOk.bind(this);
		this.onChangeReason = this.onChangeReason.bind(this);
		this.onChangeApprover = this.onChangeApprover.bind(this);
		this.cancel = this.cancel.bind(this);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const careerID = this.props.match.params.career_id;
		const classID = this.props.match.params.class_id;
		const curriculumFlg =
			this.props.match.params.curriculum_flg === '1' ? true : false;
		this.setState({
			careerID,
			classID,
			curriculumFlg,
		});

		this.props.fetchLectureCancelData(this.props.token, {
			careerID,
			classID,
			curriculumFlg,
			userAttr: this.props.userAttr,
		});

		const setDataELearning = (careerInfo: ICareerInfo) => {
			this.setState({
				careerTitle: careerInfo.careerTitle || '',
			});
		};

		const setDataCurriculum = (curriculumInfo: ICurriculumInfo) => {
			this.setState({
				careerTitle: curriculumInfo.careerName || '',
			});
		};

		if (!curriculumFlg) {
			this.props
				.doFetchCareerDetail(this.props.token, careerID)
				.then(data => setDataELearning(data.careerInfo));
		} else {
			this.props
				.doFetchCurriculumDetail(this.props.token, careerID)
				.then(data => setDataCurriculum(data.curriculumInfo));
		}
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		this.props.setLectureCancelData({});
	}

	public render() {
		const { classes, data } = this.props;
		const { careerTitle, curriculumFlg } = this.state;
		const showApprovers =
			data.approve1List || data.approve2List || data.approve4List;
		const skillViewFlg = this.props.location.state.skillViewFlg;

		return (
			<div className={classes.root}>
				<div className={classes.wrapDiv}>
					<Paper>
						{!isMobile() && (
							<Table className={this.props.classes.tableLayout}>
								<TableBody>
									<TableRow>
										<TableCell
											className={classes.cellItemName}
										>
											{!curriculumFlg &&
												!skillViewFlg &&
												i18n.t('LectureCancel_0001')}
											{!curriculumFlg &&
												skillViewFlg &&
												i18n.t('LectureCancel_0002')}
											{curriculumFlg &&
												i18n.t('LectureCancel_0003')}
										</TableCell>
										<TableCell
											className={classes.cellItemValue}
										>
											{careerTitle}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell
											className={classes.cellItemName}
										>
											{i18n.t('LectureCancel_0004')}
										</TableCell>
										<TableCell
											className={classes.cellItemValue}
										>
											<TextField
												id="multiline-flexible"
												className={classes.textArea}
												multiline={true}
												rows="4"
												margin="normal"
												value={data.reason}
												onChange={this.onChangeReason}
											/>
										</TableCell>
									</TableRow>
									{showApprovers && (
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t('LectureCancel_0005')}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{data.approve1List && (
													<div>
														<InputLabel htmlFor="acceptManagerUserID">
															{i18n.t(
																'LectureCancel_0006'
															)}
														</InputLabel>
														<Select
															id="approverId1"
															input={
																<Input
																	name="acceptManagerUserID"
																	id="acceptManagerUserID"
																/>
															}
															autoWidth={true}
															onChange={
																this
																	.onChangeApprover
															}
															value={
																data.acceptManagerUserID
															}
															displayEmpty={true}
															classes={{
																selectMenu: this
																	.props
																	.classes
																	.whiteSpace,
															}}
														>
															{data.approve1List.map(
																(
																	approver: any,
																	i: number
																): JSX.Element => (
																	<MenuItem
																		key={i}
																		value={
																			approver.userId
																		}
																		className={
																			this
																				.props
																				.classes
																				.whiteSpaceMenuItem
																		}
																	>
																		{i18n.t(
																			approver.approverOptionString,
																			{
																				ns:
																					'force',
																			}
																		)}
																	</MenuItem>
																)
															)}
														</Select>
													</div>
												)}
												{data.approve2List && (
													<div>
														<InputLabel htmlFor="acceptManagerUserID">
															{i18n.t(
																'LectureCancel_0007'
															)}
														</InputLabel>
														<Select
															id="approverId2"
															input={
																<Input
																	name="acceptManagerUserID2"
																	id="acceptManagerUserID2"
																/>
															}
															autoWidth={true}
															onChange={
																this
																	.onChangeApprover
															}
															value={
																data.acceptManagerUserID2
															}
															displayEmpty={true}
															classes={{
																selectMenu: this
																	.props
																	.classes
																	.whiteSpace,
															}}
														>
															{data.approve2List.map(
																(
																	approver: any,
																	i: number
																): JSX.Element => (
																	<MenuItem
																		key={i}
																		value={
																			approver.userId
																		}
																		className={
																			this
																				.props
																				.classes
																				.whiteSpaceMenuItem
																		}
																	>
																		{i18n.t(
																			approver.approverOptionString,
																			{
																				ns:
																					'force',
																			}
																		)}
																	</MenuItem>
																)
															)}
														</Select>
													</div>
												)}
												{data.approve4List && (
													<div>
														<InputLabel htmlFor="acceptManagerUserID">
															{i18n.t(
																'LectureCancel_0008'
															)}
														</InputLabel>
														<Select
															id="approverId4"
															input={
																<Input
																	name="acceptManagerUserID4"
																	id="acceptManagerUserID4"
																/>
															}
															autoWidth={true}
															onChange={
																this
																	.onChangeApprover
															}
															value={
																data.acceptManagerUserID4
															}
															displayEmpty={true}
															classes={{
																selectMenu: this
																	.props
																	.classes
																	.whiteSpace,
															}}
														>
															{data.approve4List.map(
																(
																	approver: any,
																	i: number
																): JSX.Element => (
																	<MenuItem
																		key={i}
																		value={
																			approver.userId
																		}
																		className={
																			this
																				.props
																				.classes
																				.whiteSpaceMenuItem
																		}
																	>
																		{i18n.t(
																			approver.approverOptionString,
																			{
																				ns:
																					'force',
																			}
																		)}
																	</MenuItem>
																)
															)}
														</Select>
													</div>
												)}
											</TableCell>
										</TableRow>
									)}
								</TableBody>
							</Table>
						)}
						{isMobile() && (
							<div className={classes.mobileTable}>
								<div className={classes.mobileCellItemName}>
									{i18n.t('LectureCancel_0001')}
								</div>
								<div className={classes.mobileCellItemValue}>
									{careerTitle}
								</div>
								<div className={classes.mobileCellItemName}>
									{i18n.t('LectureCancel_0004')}
								</div>
								<div className={classes.mobileCellItemValue}>
									<TextField
										id="multiline-flexible"
										className={classes.textArea}
										multiline={true}
										rows="4"
										margin="normal"
										value={data.reason}
										onChange={this.onChangeReason}
									/>
								</div>
								<div className={classes.mobileCellItemName}>
									{i18n.t('LectureCancel_0005')}
								</div>
								<div
									className={classes.mobileCellItemValue}
									style={{
										alignItems: 'flex-start',
										flexDirection: 'column',
									}}
								>
									{data.approve1List && (
										<div>
											<InputLabel htmlFor="acceptManagerUserID">
												{i18n.t('LectureCancel_0006')}
											</InputLabel>
											<Select
												id="approverId1"
												input={
													<Input
														name="acceptManagerUserID"
														id="acceptManagerUserID"
													/>
												}
												autoWidth={true}
												onChange={this.onChangeApprover}
												value={data.acceptManagerUserID}
												displayEmpty={true}
												classes={{
													selectMenu: this.props
														.classes.whiteSpace,
												}}
											>
												{data.approve1List.map(
													(
														approver: any,
														i: number
													): JSX.Element => (
														<MenuItem
															key={i}
															value={
																approver.userId
															}
															className={
																this.props
																	.classes
																	.whiteSpaceMenuItem
															}
														>
															{i18n.t(
																approver.approverOptionString,
																{
																	ns: 'force',
																}
															)}
														</MenuItem>
													)
												)}
											</Select>
										</div>
									)}
									{data.approve2List && (
										<div>
											<InputLabel htmlFor="acceptManagerUserID">
												{i18n.t('LectureCancel_0007')}
											</InputLabel>
											<Select
												id="approverId2"
												input={
													<Input
														name="acceptManagerUserID2"
														id="acceptManagerUserID2"
													/>
												}
												autoWidth={true}
												onChange={this.onChangeApprover}
												value={
													data.acceptManagerUserID2
												}
												displayEmpty={true}
												classes={{
													selectMenu: this.props
														.classes.whiteSpace,
												}}
											>
												{data.approve2List.map(
													(
														approver: any,
														i: number
													): JSX.Element => (
														<MenuItem
															key={i}
															value={
																approver.userId
															}
															className={
																this.props
																	.classes
																	.whiteSpaceMenuItem
															}
														>
															{i18n.t(
																approver.approverOptionString,
																{
																	ns: 'force',
																}
															)}
														</MenuItem>
													)
												)}
											</Select>
										</div>
									)}
									{data.approve4List && (
										<div>
											<InputLabel htmlFor="acceptManagerUserID">
												{i18n.t('LectureCancel_0008')}
											</InputLabel>
											<Select
												id="approverId4"
												input={
													<Input
														name="acceptManagerUserID4"
														id="acceptManagerUserID4"
													/>
												}
												autoWidth={true}
												onChange={this.onChangeApprover}
												value={
													data.acceptManagerUserID4
												}
												displayEmpty={true}
												classes={{
													selectMenu: this.props
														.classes.whiteSpace,
												}}
											>
												{data.approve4List.map(
													(
														approver: any,
														i: number
													): JSX.Element => (
														<MenuItem
															key={i}
															value={
																approver.userId
															}
															className={
																this.props
																	.classes
																	.whiteSpaceMenuItem
															}
														>
															{i18n.t(
																approver.approverOptionString,
																{
																	ns: 'force',
																}
															)}
														</MenuItem>
													)
												)}
											</Select>
										</div>
									)}
								</div>
							</div>
						)}
					</Paper>
				</div>
				<div>
					<div className={classes.column}>
						<Button
							variant="contained"
							color="primary"
							onClick={this.cancel}
						>
							{skillViewFlg
								? i18n.t('LectureCancel_0009')
								: i18n.t('LectureCancel_0010')}
						</Button>
					</div>
				</div>
				<MessageDialog
					open={this.props.dialogOpen}
					showCancelButton={false}
					title={i18n.t('LectureCancel_0011')}
					contents={[
						{
							content: skillViewFlg
								? 'LMCM_I_00860'
								: 'LMCM_I_00529',
						},
					]}
					onClose={this.onDialogOk}
					onClickOk={this.onDialogOk}
				/>
				<MessageDialog
					open={this.state.openErrorMessageDialog}
					showCancelButton={false}
					title={i18n.t('LectureCancel_0012')}
					contents={this.state.messages}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.errorMessageDialogClose}
				/>
			</div>
		);
	}

	/**
	 * エラーメッセージクローズ
	 */
	protected errorMessageDialogClose() {
		this.setState({ openErrorMessageDialog: false, messages: [] });
	}

	/**
	 * メッセージダイアログと受講取消画面をクローズ
	 */
	protected onDialogOk() {
		this.props.onClose();
		this.props.pushHistory(this.props.location.state.caller);
	}

	/**
	 * 申請理由変更処理
	 * @param event イベントオブジェクト
	 */
	protected onChangeReason(event: React.ChangeEvent<HTMLInputElement>) {
		const { data } = this.props;
		const newData = Object.assign({}, data);
		newData.reason = event.target.value;
		this.props.setLectureCancelData(newData);
	}

	/**
	 * 承認者変更処理
	 * @param event イベントオブジェクト
	 */
	protected onChangeApprover(event: React.ChangeEvent<HTMLSelectElement>) {
		const { data } = this.props;
		const { name, value } = event.target;
		const newData = Object.assign({}, data);
		newData[name] = value;
		this.props.setLectureCancelData(newData);
	}

	/**
	 * 受講申請取消処理
	 * @param event イベントオブジェクト
	 */
	protected cancel(event: React.MouseEvent<HTMLElement>) {
		const { data, userAttr, token } = this.props;
		const { careerID, classID, curriculumFlg } = this.state;

		// 入力チェック
		if (data.reason && data.reason.length > 200) {
			const message: IMessage = {
				content: 'CHK_E_0004',
				replacements: [i18n.t('LectureCancel_0013'), '200'],
			};
			this.setState({
				messages: [message],
				openErrorMessageDialog: true,
			});
			return;
		}

		this.props.saveLectureCancel(token, {
			application: data,
			careerID,
			classID,
			curriculumFlg,
			userAttr,
		});
	}
}

const mapStateToProps = (state: IRootState) => ({
	data: state.imstat.lectureCancel.data,
	dialogOpen: state.imstat.lectureCancel.dialogOpen,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	doFetchCareerDetail: (token: string, careerID: string) => {
		const s = SearchScenarioFactory.createDoFetchCareerDetail(
			dispatch,
			token
		);
		return s.run(careerID);
	},
	doFetchCurriculumDetail: (token: string, careerID: string) => {
		const s = SearchScenarioFactory.createDoFetchCurriculumDetail(
			dispatch,
			token
		);
		return s.run(careerID);
	},
	fetchLectureCancelData: (
		token: string,
		arg: IFetchLectureCancelDataParam
	) => {
		const s = ImstatScenarioFactory.createFetchLectureCancelData(
			dispatch,
			token
		);
		s.run(arg);
	},
	onClose: () => dispatch(showLectureCancelDialog({ dialogOpen: false })),
	pushHistory: (path: string) => dispatch(push(path)),
	saveLectureCancel: (token: string, arg: ISaveLectureCancelParam) => {
		const s = ImstatScenarioFactory.createSaveLectureCancel(
			dispatch,
			token
		);
		s.run(arg);
	},
	setLectureCancelData: (data: IApplication) =>
		dispatch(setLectureCancelData({ data })),
});

// tslint:disable-next-line: no-empty-interface
export interface ILectureCancelProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	ILectureCancelProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(LectureCancel);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<ILectureCancelProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/LectureCancel.tsx